import { ReactNode } from 'react'
import { Text } from '../../..'

import styles from './FilterSection.module.scss'

export interface FilterSectionProps {
  title: string
  children: ReactNode
}

export const FilterSection = ({ title, children }: FilterSectionProps) => {
  return (
    <div className={styles.section}>
      <Text align='left' element='h2' weight='bold' variantCount='900' variant='neutralCool' className={styles.title}>
        {title}
      </Text>
      {children}
    </div>
  )
}
